import { render, staticRenderFns } from "./groupTypes.vue?vue&type=template&id=0856378e&"
import script from "./groupTypes.vue?vue&type=script&lang=js&"
export * from "./groupTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports